import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';
import {AsaxElasticService} from 'asax-elastic';
import { DropdownItem } from '../search-input.model';

interface ScienceKeyword {
  readonly id: string;
  readonly text: string;
  readonly scienceCategory: ScienceKeywordCategory;
}

export interface ScienceKeywordCategory {
  readonly id: number;
  readonly name: string;
}

export interface DropdownItemScienceKeyword {
  readonly category: ScienceKeywordCategory;
  readonly scienceKeywords: DropdownItem[];
}

const scienceKeywordsIndex = 'science-keywords';

@Injectable({
  providedIn: 'root'
})
export class ScienceKeywordsService {
  constructor(private readonly asaxElasticService: AsaxElasticService) {
  }

  fetchScienceKeywords(): Observable<DropdownItemScienceKeyword[]> {
    return this.asaxElasticService.countByQuery(
      {index: scienceKeywordsIndex}
    ).pipe(
      switchMap(({count}) =>
        this.asaxElasticService.searchByQuery(
          {index: scienceKeywordsIndex, body: {size: count}}
        )
      ),
      map(({hits}) => hits?.hits.map(({_source}) => (_source))),
      map(scienceKeywords => mapItemsToDropdownItems(scienceKeywords)),
      catchError(() => [])
    );
  }
}

const mapItemsToDropdownItems = (scienceKeywords: ScienceKeyword[]): DropdownItemScienceKeyword[] => {
  const dropdownItemScienceKeywords: DropdownItemScienceKeyword[] = [];

  scienceKeywords.forEach(scienceKeyword => {
    const dropdownItemScienceKeywordExisting = dropdownItemScienceKeywords.find(item => item.category.id === scienceKeyword.scienceCategory.id);

    if (dropdownItemScienceKeywordExisting) {
      dropdownItemScienceKeywordExisting.scienceKeywords.push({value: scienceKeyword.id, text: scienceKeyword.text});
    } else {
      dropdownItemScienceKeywords.push({
        category: {name: scienceKeyword.scienceCategory.name, id: scienceKeyword.scienceCategory.id},
        scienceKeywords: [{value: scienceKeyword.id, text: scienceKeyword.text}]
      });
    }
  });

  dropdownItemScienceKeywords.forEach(category => category.scienceKeywords.sort(((a, b) => a.text.localeCompare(b.text))));
  dropdownItemScienceKeywords.sort((a, b) => a.category.name.localeCompare(b.category.name));

  return dropdownItemScienceKeywords;
};
